(function () {
  'use strict';
  function sameSite(value) {
    try { var u = new URL(value, location.href); return u.origin === location.origin && /^https?:$/.test(u.protocol) ? u : null; } catch (_) { return null; }
  }
  function isInformation(path) { return /\/(policies\/(privacy-policy|refund-policy|shipping-policy|terms-of-service|contact-information)|pages\/(contact|about|imprint|privacy-policy|trademark-notice|contact-information|review-policy|data-sharing-opt-out|html-sitemap|system-status))\/?$/.test(path); }
  function start() {
    var back = document.querySelector('[data-information-back]');
    if (back) {
      var ref = sameSite(document.referrer), record;
      try { record = JSON.parse(sessionStorage.getItem('erp-info-return') || 'null'); } catch (_) {}
      var previous = ref && ref.pathname !== location.pathname ? ref : record && record.to === location.pathname && Date.now() - record.at < 1800000 ? sameSite(record.from) : ref;
      if (previous && previous.pathname !== location.pathname) {
        back.href = previous.href;
        back.textContent = '← Return to previous page';
        back.addEventListener('click', function (event) {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (ref && ref.pathname === previous.pathname && history.length > 1) { event.preventDefault(); history.back(); }
        });
      }
    }
    document.addEventListener('click', function (event) {
      var a = event.target.closest('a[href]');
      if (!a || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || a.target === '_blank' || a.hasAttribute('download')) return;
      var dest = sameSite(a.href);
      if (dest && isInformation(dest.pathname) && dest.pathname !== location.pathname) {
        try { sessionStorage.setItem('erp-info-return', JSON.stringify({from:location.href,to:dest.pathname,at:Date.now()})); } catch (_) {}
      }
    });
    document.querySelectorAll('[data-support-copy]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var status = document.querySelector('[data-support-copy-status]');
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('clipboard unavailable');
          await navigator.clipboard.writeText(button.dataset.supportCopy);
          status.textContent = 'Email address copied. Paste it into your own email app.';
        } catch (_) { status.textContent = 'Select and copy the email address above, then paste it into your email app.'; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}());
